import { Atom } from "@effect-atom/atom";
import type { EditorTab, ResultTab } from "../lib/schemas";
import { DEFAULT_XML, DEFAULT_XSL } from "@xsltransform/shared";

// Editor content atoms
export const xmlContentAtom = Atom.make(DEFAULT_XML);
export const xslContentAtom = Atom.make(DEFAULT_XSL);
export const resultContentAtom = Atom.make("");

// Last saved content (to detect changes)
export const lastSavedXmlAtom = Atom.make(DEFAULT_XML);
export const lastSavedXslAtom = Atom.make(DEFAULT_XSL);

// Active tab atoms
export const activeEditorTabAtom = Atom.make<EditorTab>("xml");
export const activeResultTabAtom = Atom.make<ResultTab>("result");

// Normalize content for comparison
const normalize = (s: string) => s.trim();

// Derived atom: has unsaved changes
export const hasChangesAtom = Atom.make((get) => {
  const xml = get(xmlContentAtom);
  const xsl = get(xslContentAtom);
  const lastXml = get(lastSavedXmlAtom);
  const lastXsl = get(lastSavedXslAtom);

  return normalize(xml) !== normalize(lastXml) ||
         normalize(xsl) !== normalize(lastXsl);
});

// Derived atom: is default content (can't save)
export const isDefaultContentAtom = Atom.make((get) => {
  const xml = get(xmlContentAtom);
  const xsl = get(xslContentAtom);

  return normalize(xml) === normalize(DEFAULT_XML) &&
         normalize(xsl) === normalize(DEFAULT_XSL);
});

// Derived atom: can save (has changes and not default)
export const canSaveAtom = Atom.make((get) => {
  const hasChanges = get(hasChangesAtom);
  const isDefault = get(isDefaultContentAtom);

  return hasChanges && !isDefault;
});
